export const GET_ALL = "GET_ALL";
export const GET_ALL_SPONSORS = "GET_ALL_SPONSORS";
export const GET_ALL_INSTITUTIONAL = "GET_ALL_INSTITUTIONAL";
